import TotalizerDisplay from '@/components/Display/Totalizer/styles'

export default {
  TotalizerDisplay,
}
